import React from 'react';
import type { ReactNode } from 'react';

export interface StatCardProps {
  value: ReactNode;
  label: ReactNode;
  /** Value font scale. lg = 2xl, md = xl, sm = lg. */
  size?: 'sm' | 'md' | 'lg';
  /** card = bordered box; plain = centered text only. */
  variant?: 'plain' | 'card';
  /** danger renders the value in the critical-risk color. */
  tone?: 'default' | 'danger';
  className?: string;
}

export function StatCard({
  value,
  label,
  size = 'md',
  variant = 'plain',
  tone = 'default',
  className,
}: StatCardProps): React.ReactElement {
  const classes = [
    'stat-card',
    `stat-card--${variant}`,
    `stat-card--${size}`,
    tone === 'danger' ? 'stat-card--danger' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      <span className="stat-card__value">{value}</span>
      <span className="stat-card__label">{label}</span>
    </div>
  );
}
